import { useState, useEffect } from 'react';
import { message } from 'antd';
import { adminService, CreditAnalytics } from '../../api/services/adminService';

export const useCreditAnalytics = () => {
  const [analytics, setAnalytics] = useState<CreditAnalytics | null>(null);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState<[string, string] | null>(null);
  const [groupBy, setGroupBy] = useState<'day' | 'week' | 'month'>('day');

  const fetchAnalytics = async () => {
    setLoading(true);
    try {
      const params: { startDate?: string; endDate?: string; groupBy?: 'day' | 'week' | 'month' } =
        { groupBy };
      if (dateRange) {
        params.startDate = dateRange[0];
        params.endDate = dateRange[1];
      }
      const result = await adminService.getCreditAnalytics(params);
      setAnalytics(result);
    } catch {
      message.error('Failed to load credit analytics');
    } finally {
      setLoading(false);
    }
  };

  const handleDateRangeChange = (range: [string, string] | null) => {
    setDateRange(range);
  };

  const handleGroupByChange = (value: 'day' | 'week' | 'month') => {
    setGroupBy(value);
  };

  useEffect(() => {
    fetchAnalytics();
  }, [dateRange, groupBy]);

  return {
    analytics,
    loading,
    dateRange,
    groupBy,
    handleDateRangeChange,
    handleGroupByChange,
    refetch: fetchAnalytics,
  };
};
